import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Stack,
} from '@mui/material';
import { LightMode as LightModeIcon, DarkMode as DarkModeIcon } from '@mui/icons-material';
import { useThemeStore } from '../../store/themeStore';

export const AppearanceSettings: React.FC = () => {
  const { mode, toggleTheme } = useThemeStore();

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Appearance
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
        Customize how the application looks
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 400 }}>
        <FormControl component='fieldset'>
          <FormLabel component='legend'>Theme</FormLabel>
          <RadioGroup
            value={mode}
            onChange={toggleTheme}
          >
            <FormControlLabel
              value='light'
              control={<Radio />}
              label={
                <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                  <LightModeIcon />
                  <span>Light Mode</span>
                </Stack>
              }
            />
            <FormControlLabel
              value='dark'
              control={<Radio />}
              label={
                <Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
                  <DarkModeIcon />
                  <span>Dark Mode</span>
                </Stack>
              }
            />
          </RadioGroup>
        </FormControl>
      </Paper>
    </Box>
  );
};